<div [formGroup]="parentFormGroup" [ngClass]="componentClass" [class.no-label]="!label" [class.error]="isError" [class.disabled]="isDisabled" [class.has-button]="showButton" class="f-form_input autocomplete">
    <input #input
           type="text"
           [formControlName]="controlName"
           [id]="controlName"
           [name]="controlName"
           [attr.placeholder]="placeholder"
           [attr.readonly]="isSearchable ? null : ''"
           [attr.required]="isRequired ? '' : null"
           [upper-case]="upperCase"
           [value]="parentFormGroup.get(controlName).value && parentFormGroup.get(controlName).value.text && parentFormGroup.get(controlName).value.value ? (switchDisplay ? (upperCase ? parentFormGroup.get(controlName).value.value.toUpperCase() : parentFormGroup.get(controlName).value.value) : (upperCase ? parentFormGroup.get(controlName).value.text.toUpperCase() : parentFormGroup.get(controlName).value.text)) : ''"
           (focus)="showOptions = true"
           (input)="onSearch($event)"/>
    <label class="label" [for]="controlName" [innerHTML]="label" *ngIf="label"></label>
    <button #button type="button" class="f-button--link btn-ico" (click)="input.focus();isSearchable ? input.select() : false" *ngIf="showButton">
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M19.5 7.49994L12 17.9999L4.5 7.49994L19.5 7.49994Z" fill="#1890FF"/>
        </svg>        
    </button>
    <ng-container *ngIf="showOptions">
      <ul class="list-group">
        <ng-container *ngIf="!options?.length && !temporaryOptions?.length && !input?.value?.length">
          <li class="list-group-item">
            <a class="disabled text-center"><em>Please wait...</em></a>
          </li>
        </ng-container>
        <ng-container *ngIf="!options?.length && input?.value?.length">
          <li class="list-group-item">
            <a class="disabled text-center"><em>No match found</em></a>
          </li>
        </ng-container>
        <ng-container *ngFor="let option of options; let i = index">
          <li class="list-group-item"> 
            <a href="javascript: void(0)" [class.disabled]="option.disabled" [title]="showTooltip ? switchDisplay ? (upperCase ? option.text.toUpperCase() : option.text) : (upperCase ? option.value.toUpperCase() : option.value) : ''" container="body" (click)="onSelect($event, option)">
              {{ switchDisplay ? (upperCase ? option.value.toUpperCase() : option.value) : (upperCase ? option.text.toUpperCase() : option.text) }}
            </a>
          </li>
        </ng-container>
      </ul>
    </ng-container>
  </div>
  